var map = {
	"./certificado-de-garantia.svg": 989,
	"./consultante.svg": 990,
	"./courier.svg": 991,
	"./headset.svg": 992,
	"./mensajero.svg": 993,
	"./new-logo.png": 994,
	"./online-store.svg": 995,
	"./order.svg": 996,
	"./surface1.svg": 997,
	"./white-document.svg": 998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 988;